var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-conversations"},[_c('div',{staticClass:"web-conversations__container"},[_c('div',{ref:"webConversations",staticClass:"web-conversations__web-conversations",attrs:{"data-wcc-wrapper":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }